import { FiTrash2 } from "react-icons/fi"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { AlertTriangle, Trash2, Shield } from "lucide-react"
import { deleteProfile } from "../../../../services/operations/SettingsAPI"

export default function DeleteAccount() {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  async function handleDeleteAccount() {
    try {
      dispatch(deleteProfile(navigate))
    } catch (error) {
      console.log("ERROR MESSAGE - ", error.message)
    }
  }

  return (
    <div className="bg-gradient-to-br from-slate-50 via-white to-blue-50/30 py-8 px-4">
      <div className="max-w-4xl mx-auto">
        {/* Modern Header */}
        <div className="mb-2">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-gradient-to-br from-red-500 to-pink-600 rounded-2xl shadow-xl">
              <AlertTriangle className="h-6 w-6 text-white" />
            </div>
          
          <h1 className="text-4xl font-bold bg-gradient-to-r from-slate-800 to-slate-600 bg-clip-text text-transparent">
            Account Settings
          </h1>
          </div>
          <p className="text-slate-600 text-lg">Manage your account preferences and security</p>
        </div>

        {/* Delete Account Section */}
        <div className="relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-br from-red-500/5 to-pink-600/5 rounded-2xl"></div>
          <div className="relative bg-white/80 backdrop-blur-sm rounded-2xl shadow-lg border border-red-200/50 p-8">
            <div className="flex flex-col md:flex-row gap-6">
              <div className="flex-shrink-0 ">
                <div className="p-4 bg-gradient-to-br from-red-500 to-pink-600 rounded-2xl shadow-lg">
                  <Trash2 className="h-6 w-6 text-white" />
                </div>
              </div>
              
              <div className="flex-1 space-y-4">
                <div>
                  <h2 className="text-2xl font-bold text-slate-800 mb-2">Delete Account</h2>
                  <p className="text-slate-600 leading-relaxed">
                    This action is permanent and cannot be undone. All your data, including courses, progress, and personal information will be permanently deleted.
                  </p>
                </div>

                <div className="p-4 bg-amber-50/80 backdrop-blur-sm rounded-xl border border-amber-200/50">
                  <div className="flex items-start gap-3">
                    <Shield className="h-5 w-5 text-amber-600 mt-0.5" />
                    <div>
                      <h4 className="font-semibold text-amber-800 mb-1">What will be deleted:</h4>
                      <ul className="text-sm text-amber-700 space-y-1">
                        <li>• All personal information and profile data</li>
                        <li>• All HAZOP projects and worksheets</li>
                        <li>• All team memberships and assignments</li>
                      </ul>
                    </div>
                  </div>
                </div>

                <button
                  type="button"
                  onClick={handleDeleteAccount}
                  className="bg-gradient-to-r from-red-500 to-pink-600 hover:from-red-600 hover:to-pink-700 text-white py-3 px-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 flex items-center gap-2 transform hover:scale-105 font-semibold"
                >
                  <Trash2 className="h-5 w-5" />
                  I want to delete my account
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}